import { Injectable } from '@angular/core'
import { Params } from '@angular/router'
import { ResourceSlug } from '../../../shared/enums/wordpress/wp-resource-slug.enum'
import { Discussion } from '../../../shared/interfaces/discussion.interface'
import { Paginator } from '../../../shared/interfaces/paginator.interface'
import { WPDiscussion } from '../../../shared/interfaces/wordpress/wp-discussion.interface'
import { BlogResourceService } from '../../../shared/services/blog-resource.service'
import { FormatResourceService } from '../../../shared/services/format-resource.service'

@Injectable({
  providedIn: 'root'
})
export class DiscussionService {
  private discussionPerPage = 20
  constructor(
    private blogResourceService: BlogResourceService,
    private formatResourceService: FormatResourceService
  ) {}

  list(listParams: {
    page?: number
    limitTo?: number
    slug?: string
    withoutPagination?: boolean
    tagIds?: string[]
    order?: number
  }): Promise<Discussion[] | Paginator<Discussion>> {
    const params: Params = {}

    if (listParams.withoutPagination) {
      params.withoutPagination = true
      params.per_page = 100
    } else {
      params.per_page = this.discussionPerPage
      params.page = listParams.page ? listParams.page.toString() : '1'
    }

    if (listParams.slug) {
      params.slug = listParams.slug
    }

    if (listParams.tagIds) {
      params.tags = listParams.tagIds.join()
    }

    if (listParams.limitTo) {
      params.per_page = listParams.limitTo
    }

    if (listParams.withoutPagination) {
      return (
        this.blogResourceService.list(
          ResourceSlug.Discussions,
          params
        ) as Promise<WPDiscussion[]>
      ).then((wpDiscussionRes: WPDiscussion[]) =>
        wpDiscussionRes.map((WPDiscussion) =>
          this.formatResourceService.formatDiscussion(WPDiscussion)
        )
      )
    } else {
      return (
        this.blogResourceService.list(
          ResourceSlug.Discussions,
          params
        ) as Promise<Paginator<WPDiscussion>>
      ).then((wpDiscussionRes: Paginator<any>) => {
        wpDiscussionRes.data = wpDiscussionRes.data.map((WPDiscussion) =>
          this.formatResourceService.formatDiscussion(WPDiscussion)
        )

        return wpDiscussionRes
      })
    }

    // TODO: Catch
  }

  listPaginated(listParams: Params): Promise<Paginator<Discussion>> {
    listParams.withoutPagination = false
    return this.list(listParams) as Promise<Paginator<Discussion>>
  }

  listUnpaginated(listParams: Params): Promise<Discussion[]> {
    listParams.withoutPagination = true
    return this.list(listParams) as Promise<Discussion[]>
  }

  listByIds(discussionIds: number[]): Promise<Discussion[]> {
    return (
      this.blogResourceService.list(ResourceSlug.Discussions, {
        include: discussionIds.join(),
        withoutPagination: true
      }) as Promise<WPDiscussion[]>
    ).then((wpDiscussionRes: WPDiscussion[]) =>
      wpDiscussionRes.map((wpDiscussion) =>
        this.formatResourceService.formatDiscussion(wpDiscussion)
      )
    )
  }

  listBySlug(slug: string): Promise<Discussion[]> {
    return (
      this.blogResourceService.list(ResourceSlug.Discussions, {
        slug,
        withoutPagination: true
      }) as Promise<WPDiscussion[]>
    ).then((wpDiscussionRes: WPDiscussion[]) =>
      wpDiscussionRes.map((wpDiscussion) =>
        this.formatResourceService.formatDiscussion(wpDiscussion)
      )
    )
  }

  // The way to get discussion by slug instead of Id (for SEO purposes) is to filter list by slug.
  show(slug: string): Promise<Discussion> {
    return (
      this.list({ slug, withoutPagination: true }) as Promise<Discussion[]>
    ).then((wpPostRes: Discussion[]) => {
      if (!wpPostRes || !wpPostRes.length) {
        return Promise.reject('resource not found')
      }
      return wpPostRes[0]
    })
    // TODO: catch
  }
}
